import React, { useState, useCallback } from 'react';
import '../Faultanalysis_Bus/FaultSecondPage_Bus/FaultSecondPageCustom_bus.css'
import DashboardMain_Bus from '../DashboardMain_Bus/DashboardMain_Bus';
import FaultSecondPageCharts_Bus from './FaultSecondPage_Bus/FaultSecondPageChartsLine_Bus';
import FaultSecondPageDataBars_Bus from './FaultSecondPage_Bus/FaultSecondPageDataBars_Bus';
import FaultSecondPageFilters_Bus from './FaultSecondPage_Bus/FaultSecondPageFilters_Bus';
import FaultSecondPageKpis_Bus from './FaultSecondPage_Bus/FaultSecondPageKpis_Bus';
import FaultSecondPageChartsBidir_Bus from './FaultSecondPage_Bus/FaultSecondPageChartsBidir_Bus';
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_bus';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";

export default function Faultanalysis(props) {
    const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE);

    const [secondPageState, setSecondPageState] = useState({
        startDate: props.gloablfilter.startDate,
        endDate: props.gloablfilter.endDate,
        vin_num: props.gloablfilter.VIN_NUM.toString(),
        CITY: props.gloablfilter.CITY,
        DEPO: props.gloablfilter.DEPO,
    });
    const onreset = (data) => {
        setSecondPageState({
            startDate: props.gloablfilter.startDate,
            endDate: props.gloablfilter.endDate,
            vin_num: "",
            CITY: props.gloablfilter.CITY,
            DEPO: props.gloablfilter.DEPO,
        });
    }

    const filterSubmited = useCallback((data) => {
        setSecondPageState(data);
    }, []);

    return (
        <DashboardMain_Bus>
            <FaultSecondPageFilters_Bus onsubmit={filterSubmited} secondPageState={secondPageState} onreset={onreset} />
            <div className="container-fluid busdrpg1">
                <section className="graphs sec2Charts">
                    <FaultSecondPageDataBars_Bus gloablfilter={secondPageState} />
                    <div className="row mt-4 equal-cols">
                        <FaultSecondPageCharts_Bus gloablfilter={secondPageState} />
                        <FaultSecondPageChartsBidir_Bus gloablfilter={secondPageState} />
                    </div>
                </section>
            </div>
        </DashboardMain_Bus>
    )
}
